import React, { ReactChildren, ReactNode } from 'react';
import _ from 'lodash';
import cs from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  createStyles,
  WithStyles,
  Typography,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Grid,
} from '@material-ui/core';
import {

  Error
} from '@material-ui/icons';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MyPATBaseSection from './MyPATBaseSection';
import { connect } from 'react-redux';
import classNames from 'classnames';
import {ContentSaveContext} from '../mylibrary/containers/ContentCreate';

const styles = (theme: Theme) => createStyles({
  expansionPanelRoot: {
    backgroundColor: '#fff',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    '&:before': {
      backgroundColor: 'transparent'
    },
    '&#addDetails': {
      pointerEvents: 'none',
      '& $expandIcon': {
        top: 'unset',
        bottom: '-22px',
      },
      'expansionSummary': {
        display: 'block',
      },
    },
  },
  expansionPanelDefaultRoot: {
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[1],
    margin: `${theme.spacing.unit}px 0 !important`,
    borderRadius: theme.shape.borderRadius,
  },
  expansionPanelTransparentRoot: {
    backgroundColor: 'transparent',
    boxShadow: theme.shadows[0],
  },
  spaceBottom: {
    marginBottom: '15px',
  },
  spaceRight: {
    marginRight: '30px'
  },
  errorBorder: {
    border: '1px solid #F21D1D'
  },
  expansionPanelExpanded: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.12)',
    borderRadius: 4,
    // '& $expandIcon': {
    //   transform: 'translateY(-50%) rotate(90deg) !important',
    // }
  },
  expansionPanelTransparentExpanded: {
    background: '#F2F5F6',
    boxShadow: theme.shadows[0],
    '& $expandIcon': {
      transform: 'translateY(-50%) rotate(90deg) !important',
    }
  },
  expansionPanelSummaryRoot: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    backgroundColor: theme.palette.common.white,
    minHeight: 'auto !important',
    background: '#FFFFFF !important',
    // borderRadius: 4,
    borderBottom: '1px solid #DFDFDF',
    // marginBottom: '15px',
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
    marginBottom: -1,
    display: 'block',
    "&.MuiExpansionPanelSummary-focused-464": {
      backgroundColor: '#FFFFFF',
    },
  },
  expansionPanelDefaultSummaryRoot: {
    boxShadow: theme.shadows[0]
  },

  expansionPanelSummaryContent: {
    flexDirection: 'column',
    margin: '0 !important',
    '&>:first-child':{
      display: 'flex',
    },
    '& h3': {
      ...theme.typography.h6,
      fontWeight: theme.typography.fontWeightRegular,
      marginBottom: 0,
    },
    '& :first-child': {
      fontStyle: 'normal',
      fontFamily: '"Nunito", sans-serif',
      fontWeight: 400,
      fontSize: 20,
      padding: 0,
      '&>:first-child':{
        '& :nth-child(2)':{
          marginTop: 0,
          '& p': {
            fontSize: '12px',
          },
        },
      },
    },
  },

  expansionPanelDetailsRoot: {
    flexDirection: 'column',
    ...theme.mixins.gutters(),
    //paddingTop: '20px',
    //paddingBottom: '30px',
    padding: '20px',
    background: '#fff',
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    pointerEvents: 'initial',
  },

  expandIcon: {
    // backgroundColor: theme.palette.grey[300],
    // padding: theme.spacing.unit,
    // '&:hover': {
    //   backgroundColor: theme.palette.grey[300],
    // }
    '& svg':{
      transform: "scale(1.4)",
      // top: "25%",
    },
  },
  errorText: {
    color: '#333',
    verticalAlign: 'middle',
    marginTop: '5px',
    fontSize: "12px !important",
    display: "flex",
    alignItems: "center",
    '& svg': {
      verticalAlign: 'bottom',
      fontSize: "14px !important",
      marginRight: '5px',
      fill: '#F21D1D',
    }
  },
  expansion: {
    width: "100%",
    background: '#FFFFFF',
    boxShadow: '0px 0px 8px rgba(0, 0, 0, 0.287534)',
    borderRadius: 4
  },
  greyBackground: {
    // background: '#F2F5F6'
    backgroundColor: '#fff'
  },
  marginBottomSM: {
    marginBottom: 12
  },
  paddingSM: {
    paddingBottom: 16,
    paddingTop: 16,
    paddingLeft: 20,
    paddingRight: 20
   
  },
  disable: {
    '&>:nth-child(2)':{
      pointerEvents: 'none',
      opacity: 0.5
    },
  },
  progressValueText: {
    fontSize: 12,
  },
  titleText: {
    pointerEvents: 'initial',
  },
});

interface MyPATExpansionPanelProps extends WithStyles<typeof styles> {
  collapseTitle: string,
  children: ReactChildren,
  defaultExpanded: boolean,
  customCollapseTitle: ReactNode,
  panelProps: any,
  hasExpandIcon: boolean,
  expandIcon: ReactNode,
  customIcon: any;
  variant: string,
  error: boolean,
  errorText: string,
  fullWidth: boolean,
  isDisable?: boolean;
  sectionId?: string;
  sectionsTouched: Set<string>;
  showErrorOnTouch?: boolean;
}

const MyPATExpansionPanel = (props: MyPATExpansionPanelProps) => {
  const {
    collapseTitle,
    customCollapseTitle,
    children,
    defaultExpanded = true,
    hasExpandIcon = true,
    expandIcon = <ExpandMoreIcon />,
    panelProps,
    classes,
    variant,
    error = false,
    errorText,
    fullWidth = false,
    customIcon,
    isDisable,
    sectionId,
    sectionsTouched,
    showErrorOnTouch = false
  } = props;

  const generateTheme = () => {
    let themeClasses: any = {};

    switch (variant) {
      case 'default': {
        themeClasses.panelSummaryRoot = `${classes.expansionPanelDefaultSummaryRoot} ${classes.expansionPanelSummaryRoot}`;
      }
        break;
      case 'transparent': {
        themeClasses.panelRoot = `${classes.expansionPanelTransparentRoot} ${classes.marginBottomSM}`;
        themeClasses.panelExpanded = classes.expansionPanelTransparentExpanded;
        themeClasses.panelSummaryRoot = `${classes.expansionPanelSummaryRoot} ${classes.paddingSM}`;
      }
        break;
      case 'white': {
        themeClasses.panelRoot = `${classes.marginBottomSM} ${classes.expansionPanelRoot}`;
        themeClasses.panelSummaryRoot = `${classes.expansionPanelDefaultSummaryRoot} ${classes.expansionPanelSummaryRoot}`;
        themeClasses.panelExpanded = classes.expansionPanelExpanded;
        themeClasses.panelSummaryRoot = `${classes.expansionPanelSummaryRoot} ${classes.paddingSM}`;
      }
        break;
      default: {
        themeClasses.panelRoot = classes.expansionPanelRoot;
        themeClasses.panelExpanded = classes.expansionPanelExpanded;
        themeClasses.panelSummaryRoot = classes.expansionPanelSummaryRoot;
      }
    }
    return themeClasses;
  };
  const generatedClassnames = generateTheme();
  let expandIconShow = expandIcon;
  if (customIcon) {
    expandIconShow = customIcon;
  }
  const isSectionTouched = sectionsTouched.has(sectionId || '');
  const showError = showErrorOnTouch ? isSectionTouched && error : error;
  return (
   <ContentSaveContext.Consumer> 
   {({autoSave}:any)=>(  
    <MyPATBaseSection sectionId={sectionId} autoSave={autoSave}>
      <ExpansionPanel
        defaultExpanded={defaultExpanded}
        elevation={0}
        className={cs({
          [classes.spaceBottom]: true,
          [classes.expansion]: fullWidth,
          [classes.marginBottomSM]: (variant == 'transparent'),
          [classes.disable]: isDisable,
          [classes.errorBorder]: showError
        })}
        classes={{
          root: generatedClassnames.panelRoot,
          expanded: generatedClassnames.panelExpanded,
        }}
        {...panelProps}
      >
        <ExpansionPanelSummary
          expandIcon={hasExpandIcon ? <ExpandMoreIcon /> : null}
          classes={{
            content: classes.expansionPanelSummaryContent,
            root: generatedClassnames.panelSummaryRoot,
            expandIcon: !customIcon ? classes.expandIcon : "",
          }}
          className="expansionSummary"
        >
          <Grid container>
            <Grid item xs>
            {
            (_.isEmpty(customCollapseTitle) && !_.isEmpty(collapseTitle)) ? (
              <Typography component="h3">{collapseTitle}</Typography>
            ) : (
                customCollapseTitle
              )
          }
          </Grid>
          <Grid item xs="auto">
          {
            showError && errorText && (
              <Typography className={classNames(classes.errorText, hasExpandIcon && classes.spaceRight)} variant="caption" color="error">
                {/* <Error /> */}
                <img src="/assets/svg/contentRequest/blueInfo.svg"/>&nbsp;
                {errorText}</Typography>
            )
          }
            </Grid>
          </Grid>

        </ExpansionPanelSummary>

        <ExpansionPanelDetails
          classes={{
            root: [
              classes.expansionPanelDetailsRoot,
              (variant == 'transparent') && classes.greyBackground].join(' ')
          }}
        >
          {children}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </MyPATBaseSection>
   )} 
    </ContentSaveContext.Consumer>  
  );
};

const mapStateToProps = (state: any) => {
  return {
    sectionsTouched: state.commonData.focusedSection.sectionsTouched
  }
}

export default connect(mapStateToProps)(withStyles(styles)(MyPATExpansionPanel));